/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignCreateFromAtsJobRequest,
	CampaignCreateFromAtsJobResponse,
} from '../types/CampaignCreateFromAtsJob'

/**
 * POST /campaigns/from-ats-job
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::createFromAtsJob
 */
export async function campaignCreateFromAtsJob(
	data: CampaignCreateFromAtsJobRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignCreateFromAtsJobResponse>> {
	return axiosInstance.post('/campaigns/from-ats-job', data, config)
}
